import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../contexts/AuthContext";

const REDIRECT_PATH = "/user/redirect";

export const useLogin = () => {
  const { userLoggedData, signIn } = useContext(AuthContext);
  const [getErr, setErr] = useState(false);
  const [getErrMsg, setErrMsg] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const verifyLogin = async () => {
    if (userLoggedData) {
      return navigate(REDIRECT_PATH);
    }
  };

  useEffect(() => {
    verifyLogin();
  }, [userLoggedData]);

  const handleSignIn = async (event) => {
    event.preventDefault();
    setErr(false);
    setErrMsg("");
    setSuccessMessage("");
    setLoading(true);

    const data = new FormData(event.currentTarget);

    const payload = {
      email: data.get("email")?.trim(),
      password: data.get("password"),
    };

    try {
      const result = await signIn(payload);

      if (result?.success) {
        setSuccessMessage(result.message || "Login realizado com sucesso!");
        navigate(REDIRECT_PATH);
        return;
      }

      setErr(true);
      setErrMsg(result?.message || "Dados incorretos.");
    } catch (error) {
      setErr(true);
      setErrMsg(error?.message || "Erro inesperado ao realizar login.");
    } finally {
      setLoading(false);
    }
  };

  return {
    verifyLogin,
    handleSignIn,
    getErr,
    getErrMsg,
    successMessage,
    loading,
  };
};
